var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressSearchNew = function SvgAddressSearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.925 45.017H38.133c4.033-7.033 9.191-17.083 9.191-22.058 0-8.442-6.874-15.317-15.316-15.317S16.69 14.517 16.69 22.959c0 4.975 5.159 15.025 9.192 22.058H15.09l-5 13.333h43.85l-5-13.333zM32 10.3c6.974 0 12.65 5.675 12.65 12.65 0 6.15-9.925 22.917-12.65 27.117C29.233 45.8 19.35 29.084 19.35 22.95c0-6.975 5.674-12.65 12.65-12.65M16.924 47.675h10.509c1.683 2.834 2.942 4.775 3.125 4.992.358.425.892.667 1.442.667s1.083-.242 1.45-.667c.183-.208 1.433-2.15 3.124-4.992h10.509l3 8H13.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33.417c-5.742 0-10.409-4.667-10.409-10.408C21.591 17.267 26.258 12.6 32 12.6c5.741 0 10.408 4.667 10.408 10.409 0 5.741-4.667 10.408-10.408 10.408m0-18.15c-4.267 0-7.742 3.475-7.742 7.742S27.733 30.75 32 30.75s7.741-3.475 7.741-7.741c0-4.267-3.475-7.742-7.741-7.742"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgAddressSearchNew as Icon };
export default __webpack_public_path__ + "static/media/d2df16f1b09c3cb6c71da11f8dbeecc2.svg";